module.exports = __webpack_public_path__ + "static/media/e481831e-3d8f-4d66-8adf-f73336c2ae35.b787440d.png";